import { Navigate, Outlet } from 'react-router-dom';
import { useGetAuthConfigurationQuery } from '../store';
import { RouteLoader } from '../components';

export default function LegacyAuthRoute() {
  const { data, isLoading, isError, refetch } =
    useGetAuthConfigurationQuery();

  if (isLoading) return <RouteLoader />;
  if (data?.data.ssoEnabled) {
    return <Navigate to="/signin" replace />;
  }
  if (isError || !data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <p>Sign-in configuration is temporarily unavailable.</p>
        <button type="button" onClick={() => refetch()}>
          Retry
        </button>
      </div>
    );
  }
  return <Outlet />;
}
